import { Component } from '@angular/core';

@Component({
  selector: 'app-add-cart-icon',
  imports: [],
  templateUrl: './add-cart-icon.html',
  styleUrl: './add-cart-icon.scss'
})
export class AddCartIcon {

}
